import React from "react";
import styled from "styled-components";

const FooterDiv = styled.div`
  color: #939599;
  font-size: 12px;
  font-weight: 400;
  text-align: right;
  margin: 36px;
`;

const Footer = () => {
  return (
    <FooterDiv>© 2022 Coffeee.io. All rights reserved</FooterDiv>
  );
}

export default Footer;
